import React from 'react';
import styles from "./weightGainPage.module.scss";
import locales from "../../../../content.json";

const WeightGainPage = ({currentWeight, goalWeight, weightType}) => {
    let weightTypeLocales = weightType === "lbs" 
        ? locales[window.userLang].lbs_value
        : locales[window.userLang].kg_value;

    return (
        <div className={styles.weightGain}>
            <div className={styles.weightGain_title}>
                <span>{locales[window.userLang].result_short_title}</span>
            </div>
            <div className={styles.weightGain_chart}>
                <dir className={styles.weightGain_chart_header}>
                    <div className={styles.weightGain_chart_heading}>
                        <span className={styles.weightGain_chart_heading_title}>{locales[window.userLang].result_short_current_weight}</span>
                        <span className={styles.weightGain_chart_heading_data}><span className={`${styles.counter} ${styles.counter_1}`}>{currentWeight}</span>
                            <span className={styles.weightGain_chart_heading_data_units} id="counter-1-units"> {weightTypeLocales}</span></span>
                    </div>

                    <div className={styles.weightGain_chart_heading}>
                        <span className={styles.weightGain_chart_heading_title}>{locales[window.userLang].result_short_goal_weight}</span>
                        <span className={styles.weightGain_chart_heading_data}><span className={`${styles.counter} ${styles.counter_2}`}>{goalWeight}</span>
                            <span className={styles.weightGain_chart_heading_data_units} id="counter-2-units"> {weightTypeLocales}</span></span>
                    </div>
                </dir>

                <div className={styles.weightGain_chart_img} aria-hidden="true" role="presentation">
                    <div className={styles.weightGain_chart_img_columns_wrapper}>
                        <div className={`
                                ${styles.weightGain_chart_img_column_1} 
                                ${styles.weightGain_chart_img_column} 
                                ${styles.weightGain_chart_img_column__animation_1}
                            `}>
                            <span className={styles.weightGain_chart_img_column_content}>{locales[window.userLang].result_short_now}</span>
                        </div>
                        <div className={`
                                ${styles.weightGain_chart_img_column_2} 
                                ${styles.weightGain_chart_img_column} 
                                ${styles.weightGain_chart_img_column__small} 
                                ${styles.weightGain_chart_img_column__animation_2}
                            `}>
                            <span className={styles.weightGain_chart_img_column_content}>1</span>
                        </div>
                        <div className={`
                                ${styles.weightGain_chart_img_column_3} 
                                ${styles.weightGain_chart_img_column} 
                                ${styles.weightGain_chart_img_column__small} 
                                ${styles.weightGain_chart_img_column__animation_3}
                            `}>
                            <span className={styles.weightGain_chart_img_column_content}>2</span>
                        </div>
                        <div className={`
                                ${styles.weightGain_chart_img_column_4} 
                                ${styles.weightGain_chart_img_column} 
                                ${styles.weightGain_chart_img_column__small} 
                                ${styles.weightGain_chart_img_column__animation_4}
                            `}>
                            <span className={styles.weightGain_chart_img_column_content}>3</span>
                        </div>
                        <div className={`
                                ${styles.weightGain_chart_img_column_5} 
                                ${styles.weightGain_chart_img_column} 
                                ${styles.weightGain_chart_img_column__small} 
                                ${styles.weightGain_chart_img_column__animation_5}
                            `}>
                            <span className={styles.weightGain_chart_img_column_content}>4</span>
                        </div>
                        <div className={`
                                ${styles.weightGain_chart_img_column_6} 
                                ${styles.weightGain_chart_img_column} 
                                ${styles.weightGain_chart_img_column__small} 
                                ${styles.weightGain_chart_img_column__animation_6}
                            `}>
                            <span className={styles.weightGain_chart_img_column_content}>5</span>
                        </div>
                        <div className={`
                                ${styles.weightGain_chart_img_column_7} 
                                ${styles.weightGain_chart_img_column} 
                                ${styles.weightGain_chart_img_column__small} 
                                ${styles.weightGain_chart_img_column__animation_7}
                            `}>
                            <span className={styles.weightGain_chart_img_column_content}>{locales[window.userLang].result_short_week}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div className={styles.weightGain_table_title}>
                {locales[window.userLang].result_short_gain_plan}
            </div>
            <table className={styles.weightGain_table}>
                <tbody className={styles.weightGain_table_body}>
                    <tr className={styles.weightGain_table_row}>
                        <td className={`${styles.weightGain_table_cell} ${styles.weightGain_table_cell__left}`}>
                            <span className={styles.weightGain_table_icon_wrapper}>
                                <img className={styles.weightGain_table_icon} src="https://cdn.verv.com/static/verv/ios/paywall/pv3br2pgav2p/fire.svg" alt='icon'/>
                            </span>
                            {locales[window.userLang].result_short_calories_burn}
                        </td>
                        <td className={`${styles.weightGain_table_cell} ${styles.weightGain_table_cell__right}`}>
                            <span id="calories">650</span>&nbsp;{locales[window.userLang].calories_value}
                        </td>
                    </tr>
                    <tr className={styles.weightGain_table_row}>
                        <td className={`${styles.weightGain_table_cell} ${styles.weightGain_table_cell__left}`}>
                            <span className={styles.weightGain_table_icon_wrapper}>
                                <img className={styles.weightGain_table_icon} src="https://cdn.verv.com/static/verv/ios/paywall/pv3br2pgav2p/human.svg" alt='icon'/>
                            </span>
                            {locales[window.userLang].result_short_workouts_type}
                        </td>
                        <td className={`${styles.weightGain_table_cell} ${styles.weightGain_table_cell__right}`} id="workouts">
                            {locales[window.userLang].result_short_workouts_name}
                        </td>
                    </tr>
                    <tr className={styles.weightGain_table_row}>
                        <td className={`${styles.weightGain_table_cell} ${styles.weightGain_table_cell__left}`}>
                            <span className={styles.weightGain_table_icon_wrapper}>
                                <img className={styles.weightGain_table_icon} src="https://cdn.verv.com/static/verv/ios/paywall/pv3br2pgav2p/clocks.svg" alt='icon'/>
                            </span>
                            {locales[window.userLang].result_short_workouts_duration}
                        </td>
                        <td className={`${styles.weightGain_table_cell} ${styles.weightGain_table_cell__right}`}>
                            <span id="workouts-duration">20</span>&nbsp;{locales[window.userLang].result_short_workouts_duration_min}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>  
    )
}

export default WeightGainPage;